<ng-container *ngIf="question$ | async as questionInfo">
  <div id="questionPage" class="color-primary">
    <div class="row justify-content-lg-end pad-t-6 pad-r-t-5">
      <div class="col-lg-4 d-flex align-items-center time-row" *ngIf="timeSpent != null" >
        <div class="d-inline-block w-100 body-s">
          <div class="position-relative">
            <span *ngIf="(timeSpent * 100 / (questionInfo.maxLevelDuration/60)) < 100" [style]="'left:'+(timeSpent * 100 / (questionInfo.maxLevelDuration/60))+'%'">
              {{ (timeSpent <= 1 ? ('TEST.' + questionInfo.testModelId + '.MINUTESREMAINING.SINGULAR'): ('TEST.' + questionInfo.testModelId + '.MINUTESREMAINING.PLURAL'))  | translate: { minutes: timeSpent } }}
            </span>
            <ngb-progressbar
              [value]="(timeSpent * 100 / (questionInfo.maxLevelDuration/60))"
              [ngClass]="'custom-progress'"
              [ngStyle]="{'background-color': '#D7D7D7'}"
              height="15px"
            >
            </ngb-progressbar>
          </div>
          <div class="mar-t-1 d-flex justify-content-between">
            <p>{{ ('TEST.' + questionInfo.testModelId + '.QUESTIONPERTOTAL') | translate: { x:questionData.position, y:questionInfo.questionsInLevel} }}</p>
            <p>{{ (questionInfo.maxLevelDuration/60 <= 1 ? ('TEST.' + questionInfo.testModelId + '.MINUTESREMAINING.SINGULAR'): ('TEST.' + questionInfo.testModelId + '.MINUTESREMAINING.PLURAL'))  | translate: { minutes: questionInfo.maxLevelDuration/60 } }}</p>
          </div>
        </div>
      </div>
    </div>

    <hr class="w-100 mar-y-3">

    <div>
      <div class="title-m title-r-s mar-b-2 mar-r-b-1" *ngIf="questionInfo.testModelId == 24">
        <span *ngIf="questionType !== 'longQuestion'">{{ 'TEST.' + questionInfo.testModelId + '.ANSWER' | translate }}</span>
        <span *ngIf="questionType === 'longQuestion'">{{ 'TEST.' + questionInfo.testModelId + '.READANSWER' | translate }}</span>
      </div>
        
      <ng-container *ngIf="questionType === 'shortQuestion' || questionType === 'image'">
        <!-- título de la pregunta -->
        <p  *ngIf="questionType === 'shortQuestion'" class="body-l body-r-m color-secondary mar-b-3 mar-r-b-2"> {{questionData.title}}</p>
        <!-- enunciado de la pregunta -->
        <div class="title-xs mar-b-2">
          <div [innerHTML]="questionData.description"></div>
          <div class="row" *ngIf="questionType === 'image'">
            <div class="col-lg-4">
              <img class="w-100" [src]="questionData.media">
            </div>
          </div>
        </div>
        <p  *ngIf="questionType === 'image'" class="body-l title-r-xs mar-b-3 mar-r-b-2"> {{questionData.title}}</p>
        <!-- opciones de respuesta -->
        <div class="body-l mar-b-3">
          <div class="mar-b-2" *ngFor="let option of questionData.options; let i= index">
            <input type="radio" class="d-inline-flex justify-content-center align-items-center" [value]=option.id [(ngModel)]="optionId">
            <span *ngIf="!option.media">{{ option.description }}</span>
            <span *ngIf="option.media" class="row d-inline-flex">
              <div class="col-5">
                <img class="w-100" [src]="option.media">
              </div>
            </span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="questionType === 'longQuestion'">
        <!-- texto de la pregunta -->
        <div class="body-l body-r-m color-secondary mar-b-3 mar-r-b-2" [innerHTML]="questionData.description"></div>
        <hr class="w-100 mar-y-2">
        <!-- titulo de la pregunta -->
        <div class="title-xs mar-b-2">{{questionData.title}}</div>
        <!-- opciones de respuesta -->
        <div class="body-l mar-b-3">
          <div class="mar-b-2" *ngFor="let option of questionData.options; let i= index">
            <input type="radio" class="d-inline-flex justify-content-center align-items-center" [value]=option.id [(ngModel)]="optionId">
            <span *ngIf="!option.media">{{ option.description }}</span>
            <span *ngIf="option.media"><img [src]="option.media"></span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="questionType === 'audio'">
        <!-- título de la pregunta -->
        <p class="body-l body-r-m color-secondary mar-b-3 mar-r-b-2">{{questionData.title}}</p>
        <!-- archivo multimedia -->
        <div class="mar-b-3 mar-r-b-2">
          <audio [src]="questionData.media" controls controlsList="nodownload"></audio>
        </div>
        <!-- enunciado de la pregunta -->
        <div class="title-xs mar-b-2">
          <div [innerHTML]="questionData.description"></div>
        </div>
        <!-- opciones de respuesta -->
        <div class="body-l mar-b-3">
          <div class="mar-b-2" *ngFor="let option of questionData.options; let i= index">
            <input type="radio" class="d-inline-flex justify-content-center align-items-center" [value]=option.id [(ngModel)]="optionId">
            <span *ngIf="!option.media">{{ option.description }}</span>
            <span *ngIf="option.media"><img [src]="option.media"></span>
          </div>
        </div>
      </ng-container>
    </div>

    <button class="btn nextQuestionButton" (click)="setAnswer()" [disabled]="!optionId">{{ 'COMMON.NEXT' | translate }}</button>
  </div>
</ng-container>

